import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_CUSTOMER_WHD_REQUEST = 'GET_CUSTOMER_WHD_REQUEST';
export const GET_CUSTOMER_WHD_SUCCESS = 'GET_CUSTOMER_WHD_SUCCESS';
export const GET_CUSTOMER_WHD_FAILURE = 'GET_CUSTOMER_WHD_FAILURE';
export const RESET_WHD_RATES = 'RESET_WHD_RATES';

function requestGetWhd(customerId, accountId) {
  return {
    type: GET_CUSTOMER_WHD_REQUEST,
    isGettingWhd: true,
    accountId,
    customerId,
  };
}

function receiveGetWhd(accountWithholdingRates, customerId, accountId) {
  return {
    type: GET_CUSTOMER_WHD_SUCCESS,
    isGettingWhd: false,
    accountWithholdingRates,
    customerId,
    accountId
  };
}

function rejectGetWhd(customerId, accountId) {
  return {
    type: GET_CUSTOMER_WHD_FAILURE,
    isGettingWhd: false,
    customerId,
    accountId
  };
}

function resetWhdRates() {
  return {
    type: RESET_WHD_RATES,
  };
}

export function getWhdDetails(customerId, accountId) {
  return (dispatch) => {
    dispatch(requestGetWhd(customerId, accountId));
    const promise = () => ApiService
      .getCustomerAccountWithholdingRates(customerId, accountId)
      .then((response) => {
        dispatch(receiveGetWhd(response.data, customerId, accountId));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetWhd(customerId, accountId), true));
        }
      });
    return promise();
  };
}

export function resetWithholdingRates() {
  return dispatch => dispatch(resetWhdRates());
}
